module.exports = __webpack_public_path__ + "static/media/mecircle.9459b9e7.png";